import React from 'react';

import {
	EXTERNAL_LINK_GNDI_MINAS,
	CHAT_ROOMS_GNDI_MINAS,
	PRODUCT_CODE,
	PRODUCT_NAME,
	ProductEnum,
	PRODUCT_FOOTER_NAME,
	PRODUCT_LINK_IOS_STORE,
	PRODUCT_LINK_ANDROID_STORE,
} from 'presentation/constants';
import {GndiMinasLogo, GndiMinasIcon, GndiMinasAns} from 'presentation/components/Logos';
import {GndiMinasAppIcon} from 'presentation/components/Logos/GndiMinas/GndiMinasAppIcon';
import {AnsLogoProps, ProductIconProps, ProductLogoProps} from '../types';
import {useThemeStore} from 'presentation/store/useThemeStore';

const theme = useThemeStore.getState().theme;

export const gndiMinasData = {
	productLogo: ({invertColor, nameColor, ...props}: ProductLogoProps) => (
		<GndiMinasLogo
			nameColor={nameColor || (invertColor ? theme.brand.primary.white : undefined)}
			invertColor={invertColor}
			{...props}
		/>
	),
	productIcon: ({color, invertColor, ...props}: ProductIconProps) => (
		<GndiMinasIcon
			color={color || (invertColor ? theme.brand.primary.white : undefined)}
			{...props}
		/>
	),
	productAppIcon: (props: ProductIconProps) => <GndiMinasAppIcon {...props} />,
	ansLogo: (props?: AnsLogoProps) => <GndiMinasAns {...props} />,
	product: ProductEnum.GNDI_MINAS,
	productCode: PRODUCT_CODE.gndiminas,
	productName: PRODUCT_NAME.gndiminas,
	footerProductName: PRODUCT_FOOTER_NAME.gndiminas,
	links: EXTERNAL_LINK_GNDI_MINAS,
	chatRoom: CHAT_ROOMS_GNDI_MINAS,
	iosStoreLink: PRODUCT_LINK_IOS_STORE.gndiminas,
	androidStoreLink: PRODUCT_LINK_ANDROID_STORE.gndiminas,
};
